class Sofatutor.Classes.BasicTest
  constructor: ->
    @$questionAnswers = $('.shared-feature-question__answers')

    $(document).trigger('initialize-feature-question')
    @toggleState()

  isCompleted: ->
    $('li', @$questionAnswers).hasClass('is-wrong') || $('li', @$questionAnswers).hasClass('is-correct')

  disable: ->
    @$questionAnswers.removeClass('is-enabled')

  toggleState: ->
    if @isCompleted()
      @disable()
    else
      _.defer =>
        $(document).trigger 'questionShown'
        @$questionAnswers.addClass('is-enabled')
